class VwHbsHastarecete1DTO {
    id: number = null;
    muracaatId?: number = null;
    servisId?: number = null;
    drId?: number = null;
    hastaservisId?: number = null;
    tarih?: string = null;
    aciklama?: string = "";
    fkRecetetur?: number = null;
    saat?: string = "";
    fkRecetealttur?: number = null;
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptal?: string = "H";
    iptalKullanici?: number = null;
    iptalTarihi?: string = null;
    fkIptalneden?: number = null;
    iptalaciklama?: string = "";
}
export default VwHbsHastarecete1DTO;